// extracted by mini-css-extract-plugin
module.exports = {"nav__back":"NavBack_nav__back__Q6JCX","nav__back-btn":"NavBack_nav__back-btn__1CEvt"};